module.exports = __webpack_public_path__ + "img/marsh-logo-green.bc91ffd6.svg";